var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"w-100"},[_c('BarChart',{ref:"BaseChart",staticClass:"barchart",attrs:{"title":'Hi Chisom',"chartOptions":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }